import script from "./competenze.vue?vue&type=script&setup=true&lang=js"
export * from "./competenze.vue?vue&type=script&setup=true&lang=js"

import "./competenze.vue?vue&type=style&index=0&id=07ac95db&lang=css"

const __exports__ = script;

export default __exports__